module.exports = __webpack_public_path__ + "img/ic_logout.c7b473ad.svg";